const ISO_DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

function pad2(value: number): string {
  return value < 10 ? `0${value}` : String(value);
}

export function dateToLocalDateKey(date: Date): string {
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
}

// Same result as moment(value).format("YYYY-MM-DD") for the ISO 8601 strings the API returns, without
// allocating a moment per call. Date-only strings are already the key (moment reads them as local dates).
export function localDateKey(value: string): string | null {
  if (ISO_DATE_ONLY.test(value)) {
    return value;
  }
  const time = Date.parse(value);
  if (Number.isNaN(time)) {
    return null;
  }
  return dateToLocalDateKey(new Date(time));
}

export function todayLocalDateKey(): string {
  return dateToLocalDateKey(new Date());
}

// Same result as moment(value).toISOString(): date-only strings are local midnight, anything else is parsed
// as-is. Returns null for values moment would consider invalid.
export function toIsoDatePoint(value: string): string | null {
  if (ISO_DATE_ONLY.test(value)) {
    const [year, month, day] = value.split("-").map(Number);
    return new Date(year, month - 1, day).toISOString();
  }
  const time = Date.parse(value);
  if (Number.isNaN(time)) {
    return null;
  }
  return new Date(time).toISOString();
}

export function nowIsoDatePoint(): string {
  return new Date().toISOString();
}
